<div class="skeleton-loader" *ngIf="statusDetail == 'loading'">
  <div
    class="charging-content"
    *ngFor="let item of [0, 1, 2, 3, 4, 5, 6]"
  ></div>
</div>

<div class="list" *ngIf="statusDetail == 'success'">
    <div class="search-container">
      <mat-form-field appearance="outline" class="search-field alt-inter-medium alt-size-14" style="width: 300px">
        <mat-label>{{ 'Buscar por nombre, apellido' | translate }}</mat-label>
        <input
          matInput
          (input)="onSearchQueryInput($event)"
          placeholder="Buscar por nombre, apellido"
          width="350px"
        />
      </mat-form-field>
    </div>

  <div *ngIf="isEmptySearch === false; else noMatches">
    <table matSort (matSortChange)="sortData($event)" mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="image">
        <th
          class="image-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        ></th>
        <td
          (click)="goToSpecificFacilitator(element.id)"
          class="image-column alt-inter-medium alt-size-14 clickable"
          mat-cell
          *matCellDef="let element"
          [class.row-disabled]="element.status == 'disabled'"
        >
          <div class="image-profile">
            <img [src]="element.picture ?? 'assets/icons/CatUser.svg'" />
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Nombre">
        <th
          class="name-header alt-inter-semibold alt-size-14"
          mat-sort-header="names"
          mat-header-cell
          *matHeaderCellDef
        >
          <div class="title-container alt-row-align-center">
            <p class="title_inside">
              {{ "ORGANIZATION.name-header" | translate }}
            </p>
          </div>
        </th>

        <td
          (click)="goToSpecificFacilitator(element.id)"
          class="name-column alt-inter-medium alt-size-14 clickable"
          mat-cell
          *matCellDef="let element"
          [class.row-disabled]="element.status == 'disabled'"
        >
          <div class="content-container alt-column-justify-center">
            <p
              class="name-text alt-color-grayscale1 alt-inter-medium alt-size-14"
            >
              {{ element.names }} {{ element.surnames }}
            </p>
            <div
              class="ranking-container alt-flex-row alt-inter-bold alt-size-14"
            >
              <div class="row alt-row-align-center gap-2">
                <mat-icon
                  class="star-icon alt-color-bran2"
                  svgIcon="faceSad"
                ></mat-icon>
                <p class="score-value alt-inter-bold alt-color-grayscale1">
                  {{ element.feedback?.bad ?? 0 }}
                </p>
                <mat-icon class="star-icon" svgIcon="faceSmile"></mat-icon>
                <p class="score-value alt-inter-bold alt-color-grayscale1">
                  {{ element.feedback?.normal ?? 0 }}
                </p>
                <mat-icon
                  class="star-icon alt-color-bran3"
                  svgIcon="faceLove"
                ></mat-icon>
                <p class="score-value alt-inter-bold alt-color-grayscale1">
                  {{ element.feedback?.good ?? 0 }}
                </p>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Correo electronico">
        <th
          class="email-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          <div class="title-container alt-row-align-center">
            <p class="title_inside">{{ "AUTH.email-field" | translate }}</p>
          </div>
        </th>
        <td
          (click)="goToSpecificFacilitator(element.id)"
          class="email-column alt-inter-medium alt-size-14 clickable"
          mat-cell
          *matCellDef="let element"
          [class.row-disabled]="element.status == 'disabled'"
        >
          <div class="content-container alt-column-justify-center">
            <p
              class="email-text alt-color-grayscale1 alt-inter-medium alt-size-14"
            >
              {{ element.email }}
            </p>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Teléfono">
        <th
          class="phone-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
            {{ "FACILITATOR.phone-number" | translate }}
        </th>
        <td
          (click)="goToSpecificFacilitator(element.id)"
          class="phone-column alt-inter-medium alt-size-14 clickable"
          mat-cell
          *matCellDef="let element"
          [class.row-disabled]="element.status == 'disabled'"
        >
          <div class="content-container alt-column-justify-center">
            <div class="alt-row-justify-center">
              <p
                class="margin-cero"
              >
                {{ element.phone_number }}
              </p>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="Grupo a cargo">
        <th
          class="group-header alt-inter-semibold alt-size-14"
          mat-header-cell
          *matHeaderCellDef
        >
          {{ "FACILITATOR.grouOnCharge" | translate }}
        </th>
        <td
          (click)="goToSpecificFacilitator(element.id)"
          class="group-column alt-inter-medium alt-size-14 clickable"
          mat-cell
          *matCellDef="let element"
        >
          <div class="content-container alt-column-justify-center">
            <div class="grups-charge-container">
              <div class="container-group grups-charge-container">
                <p class="margin-cero alt-inter-semibold alt-size-10">
                  {{ element.groups | uppercase }}
                </p>
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <!-- Compañía -->
      <ng-container matColumnDef="agency">
        <th mat-header-cell *matHeaderCellDef style="width: 150px">Agencia</th>
        <td mat-cell *matCellDef="let element">{{ element.agency }}</td>
      </ng-container>

      <ng-container matColumnDef="Fecha de creación">
        <th
          mat-header-cell
          mat-sort-header="created_At"
          *matHeaderCellDef
        >
            Creación
        </th>
        <td
          (click)="goToSpecificFacilitator(element.id)"
          class="date-column clickable"
          mat-cell
          *matCellDef="let element"
          [class.row-disabled]="element.status == 'disabled'"
        >
            {{ element.created_At | dateFormat }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Estado">
        <th
          mat-header-cell
          *matHeaderCellDef
        >
          Estado
        </th>
        <td
          (click)="goToSpecificFacilitator(element.id)"
          class="state-column alt-inter-medium alt-size-14 clickable"
          mat-cell
          *matCellDef="let element"
        >
          <div>
            <p
              class="alt-inter-semibold alt-size-10 disable-status"
              [ngStyle]="{
                'background-color': chooseColorAndText(element.status).color
              }"
            >
              {{
                chooseColorAndText(element.status).text | translate | uppercase
              }}
            </p>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]"
      (page)="handlePageEvent($event)"
      [pageSize]="pageSize"
      [length]="length"
      [pageIndex]="pageIndex - 1"
      [showFirstLastButtons]=true
      aria-label="Select page"
      >></mat-paginator
    >
  </div>

  <ng-template #noMatches>
    <div class="container-matches">
      <app-no-matches></app-no-matches>
    </div>
  </ng-template>
</div>

<div
  *ngIf="statusDetail === 'success' && noInitialData"
  class="container-matches"
>
  <div class="no-users-created alt-justify-center">
    <mat-icon class="image-no-data" svgIcon="noDataList"></mat-icon>
  </div>
  <p
    class="text-info-no-users alt-color-grayscale1 alt-size-14 alt-inter-semibold"
  >
    {{ "USERS.noDataText" | translate }}
    {{ "FACILITATOR.facilitator" | translate }}es
  </p>
</div>
